// 首页报名、比赛报名页与管理员修改报名共用同一组选项，避免请假原因不一致。
export const LEAVE_REASONS = [
    { label: '工作', value: '工作原因' },
    { label: '家庭', value: '家庭原因' },
    { label: '身体', value: '身体原因' },
    { label: '饭局', value: '饭局' },
    { label: '出差', value: '出差' },
    { label: '其他', value: '其他' },
];
